import type { ReactNode } from 'react';
import { Info } from 'lucide-react';

/**
 * InfoHint — mała niebieska ramka z objaśnieniem pod polem formularza.
 *
 * Do kontekstowych podpowiedzi „co robi to pole" mocniejszych niż szary `hint`
 * (np. wyjaśnienie pola „Kolejność sortowania"). Współdzielona — ten sam wzorzec
 * używamy w panelu ITE i u tenanta.
 */
export function InfoHint({ children }: { children: ReactNode }) {
  return (
    <div
      className="mt-1.5 flex gap-2 rounded-md border border-blue-200 bg-blue-50 px-3 py-2 text-xs text-blue-800 dark:border-blue-900/60 dark:bg-blue-950/40 dark:text-blue-200"
      role="note"
    >
      <Info className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" />
      <span>{children}</span>
    </div>
  );
}
